import {
  createSlice,
  createSelector,
  createAsyncThunk,
} from '@reduxjs/toolkit';
import _ from 'lodash';
import { clearError, reduxDefaultStatusControl } from 'src/tools/helper';
import history from 'src/router/history';
import { msg } from 'src/tools/message';
import { addSupplier as apiAddSupplier } from 'src/request/common/supplier';
import {
  postStock,
  getStockPage,
  getStockDetail,
} from 'src/request/stock/stock';
import { stockInfoCheck } from '../sotckInfo';
import { stockProductsCheck } from '../stockProducts';
import { settleData } from '../submitData';

const defaultState = {
  ...reduxDefaultStatusControl,
  suppliers: [],
  storeUuid: '1',
  stockInfo: {
    supplier: null,
    warehouse: null,
    stockInDate: null,
    total: 0,
    orderNo: '',
    notes: '',
  },
  stockItems: [],
  //status: EnumStatus.Draft,
};
export const fetchStock = createAsyncThunk('fetchStock', async () => {
  const response = await getStockPage();
  return response;
});

export const fetchStockDetail = createAsyncThunk(
  'fetchStockDetail',
  async (uuid: string) => {
    const response = await getStockDetail(uuid);
    return response;
  },
);
export const submitStock = createAsyncThunk(
  'submitStock',
  async (stock: any) => {
    const response = await postStock(stock);
    return response;
  },
);
export const addSup = createAsyncThunk('addSupplier', async (s: any) => {
  const response = await apiAddSupplier(s);
  return response;
});

const stockSlice = createSlice({
  name: 'stock',
  initialState: defaultState,
  reducers: {
    setInfo(state, action) {
      state.hasModified = true;
      const infoObject = action.payload || {};
      state.stockInfo = {
        ...state.stockInfo,
        ...clearError(infoObject),
      };
    },
    setProducts(state, action) {
      state.hasModified = true;
      const { index, modifiedItems } = action.payload;
      const item = state.stockItems[index] || {};
      state.stockItems[index] = { ...item, ...clearError(modifiedItems) };
    },
    deleteProduct(state, action) {
      state.hasModified = true;

      state.stockItems.splice(action.payload, 1);
    },
    reselectProducts(state, action) {
      state.hasModified = true;
      const { products } = action.payload;
      state.stockItems = products;
    },
    emptyData(state) {
      state.hasModified = false;
      Object.keys(defaultState || {}).forEach((i) => {
        state[i] = defaultState[i];
      });
    },

    validate(state) {
      const check = () => {
        const { data: infoData, flag: infoFlag } = stockInfoCheck(
          state.stockInfo,
        );
        if (infoFlag) {
          state.stockInfo = infoData;
          state.dataValid = false;
          return;
        }
        const { data: itemData, flag: itemFlag } = stockProductsCheck(
          state.stockItems,
        );
        if (itemFlag) {
          state.stockItems = itemData;
          state.dataValid = false;
          return;
        }
        state.dataValid = true;
        return;
      };
      check();
    },
  },
  extraReducers: (builder) => {
    builder.addCase(addSup.fulfilled, (state, action) => {
      state.suppliers.push(action.payload);
    });
    builder.addCase(fetchStock.fulfilled, (state, action: any) => {
      const { suppliers } = action.payload;
      state.suppliers = suppliers;
      state.loaded = false;
    });

    builder.addCase(fetchStockDetail.fulfilled, (state, action) => {
      const {
        warehouse,
        supplier,
        stockInDate,
        orderNo,
        notes,
        total,
        stockItems,
      } = action.payload;
      state.stockInfo.warehouse = warehouse;
      state.stockInfo.supplier = supplier;
      state.stockInfo.stockInDate = stockInDate;
      state.stockInfo.orderNo = orderNo;
      state.stockInfo.notes = notes;
      state.stockInfo.total = total;
      state.stockItems = stockItems;
    });

    builder.addCase(submitStock.fulfilled, (state, action) => {
      state.hasModified = false;
      _.delay(() => {
        msg.success('saved successfully!');
        history.push('/stockList');
      }, 500);
    });
    builder.addCase(submitStock.rejected, (state, action) => {
      state.hasModified = true;
    });
  },
});
export const getSubmitStock = () => {
  return createSelector([(state: any) => state.stock], (stock) => {
    return settleData(stock);
  });
};
export const getInfo = () => {
  return createSelector(
    [(state: any) => state.stock.stockInfo],
    (stockInfo) => {
      return stockInfo; //settleData(stock);
    },
  );
};
export const getProducts = () => {
  return createSelector(
    [(state: any) => state.stock.stockItems],
    (stockItems) => {
      return stockItems; //settleData(stock);
    },
  );
};

export const getSuppliers = () => {
  //suppliers
  return createSelector(
    [(state: any) => state.stock.suppliers],
    (suppliers) => {
      return suppliers || []; //settleData(stock);
    },
  );
};
export const {
  emptyData,
  setProducts,
  validate,
  setInfo,
  reselectProducts,
  deleteProduct,
} = stockSlice.actions;

export default stockSlice.reducer;
